import { Navigate } from 'react-router-dom';

import { useAuth } from '../providers/AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { hasUser } = useAuth();

  if (!hasUser) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
